import { AccordionType } from 'types';
import parse from 'html-react-parser';
import { Accordion, AccordionTab } from 'primereact/accordion';
import VideoBox from 'components/videoBox/VideoBox';

interface AccordionProps {
  accordionData?: any;
}

export default function AccordionSection({ accordionData }: AccordionProps) {
  return (
    <div>
      {accordionData?.map((accordion: AccordionType) => (
        <section key={Math.random()} className="container mx-auto px-4 my-8">
          {!!accordion?.header && (
            <h3 className="text-center">{parse(accordion?.header?.html)}</h3>
          )}
          <Accordion activeIndex={0}>
            {accordion.accordionContent?.map(accordionContentItem => (
              <AccordionTab
                key={Math.random()}
                header={
                  accordionContentItem?.contentHeader && (
                    <h4>{parse(accordionContentItem?.contentHeader?.html)}</h4>
                  )
                }>
                {!!accordionContentItem.contentDescription && (
                  <div className="parsed-content body-parsed-text opacity-90">
                    {parse(accordionContentItem?.contentDescription?.html)}
                  </div>
                )}
                {!!accordionContentItem.contentImage && (
                  <img
                    src={accordionContentItem.contentImage.url}
                    alt=""
                    className="mx-auto block"
                    style={{ objectFit: 'contain', maxHeight: '400px' }}
                  />
                )}
                <VideoBox
                  videoTitle={accordionContentItem?.videoBox?.videoTitle}
                  vimeoVideoId={accordionContentItem?.videoBox?.vimeoVideoId}
                  youtubeVideoId={
                    accordionContentItem?.videoBox?.youtubeVideoId
                  }
                  youtubePlaylistId={
                    accordionContentItem?.videoBox?.youtubePlaylistId
                  }
                />
              </AccordionTab>
            ))}
          </Accordion>
        </section>
      ))}
    </div>
  );
}
